import React, { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { string } from 'prop-types';

import SnapaskHeader from 'components/SnapaskHeader';
import SnapaskFooter from 'components/SnapaskFooter';
import {
  fetchInstructorList,
  fetchInstructorListClear,
} from 'reduxModules/instructorProfile/action';

import Instructors from './components/Instructors';
import Jumbotron from './components/Jumbotron';
import CtaFooter from './components/CtaFooter';

function InstructorList({ contentType }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchInstructorList({ type: contentType }));
    return () => dispatch(fetchInstructorListClear());
  }, [contentType, dispatch]);

  const instructorListRef = useRef(null);
  const onCtaClick = () => {
    instructorListRef.current.scrollIntoView();
  };
  return (
    <>
      <SnapaskHeader />
      <Jumbotron onCtaClick={onCtaClick} />
      <Instructors
        contentType={contentType}
        instructorListRef={instructorListRef}
      />
      <CtaFooter contentType={contentType} />
      <SnapaskFooter />
    </>
  );
}
InstructorList.propTypes = {
  contentType: string.isRequired,
};
export default InstructorList;
